"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const namesData = [{
  name: "Abel",
  meaning: "Breath",
  letter: "A"
}, {
  name: "Abraham",
  meaning: "Father of many",
  letter: "A"
}, {
  name: "Abram",
  meaning: "Exalted father",
  letter: "A"
}, {
  name: "Ace",
  meaning: "One, unity",
  letter: "A"
}, {
  name: "Adair",
  meaning: "Oak tree ford",
  letter: "A"
}, {
  name: "Adam",
  meaning: "Son of the red earth",
  letter: "A"
}, {
  name: "Adler",
  meaning: "Eagle",
  letter: "A"
}, {
  name: "Adonis",
  meaning: "Lord",
  letter: "A"
}, {
  name: "Adrian",
  meaning: "From Hadria",
  letter: "A"
}, {
  name: "Aiden",
  meaning: "Little fire",
  letter: "A"
}, {
  name: "Alaric",
  meaning: "All-powerful ruler",
  letter: "A"
}, {
  name: "Albert",
  meaning: "Noble, bright",
  letter: "A"
}, {
  name: "Alden",
  meaning: "Old friend",
  letter: "A"
}, {
  name: "Alexander",
  meaning: "Defender of the people",
  letter: "A"
}, {
  name: "Alfie",
  meaning: "Wise counselor",
  letter: "A"
}, {
  name: "Alfred",
  meaning: "Elf counsel",
  letter: "A"
}, {
  name: "Alistair",
  meaning: "Defender of men",
  letter: "A"
}, {
  name: "Alonzo",
  meaning: "Noble, ready",
  letter: "A"
}, {
  name: "Alvin",
  meaning: "Noble friend",
  letter: "A"
}, {
  name: "Ambrose",
  meaning: "Immortal",
  letter: "A"
}, {
  name: "Amos",
  meaning: "Carried by God",
  letter: "A"
}, {
  name: "Anders",
  meaning: "Strong and manly",
  letter: "A"
}, {
  name: "Andrew",
  meaning: "Strong and manly",
  letter: "A"
}, {
  name: "Angus",
  meaning: "One strength",
  letter: "A"
}, {
  name: "Ansel",
  meaning: "With divine protection",
  letter: "A"
}, {
  name: "Anthony",
  meaning: "Priceless one",
  letter: "A"
}, {
  name: "Apollo",
  meaning: "Destroyer",
  letter: "A"
}, {
  name: "Archer",
  meaning: "Bowman",
  letter: "A"
}, {
  name: "Archie",
  meaning: "Truly brave",
  letter: "A"
}, {
  name: "Ares",
  meaning: "Bane, ruin",
  letter: "A"
}, {
  name: "Arlo",
  meaning: "Between two hills",
  letter: "A"
}, {
  name: "Armani",
  meaning: "Warrior",
  letter: "A"
}, {
  name: "Arnold",
  meaning: "Eagle power",
  letter: "A"
}, {
  name: "Arthur",
  meaning: "Bear",
  letter: "A"
}, {
  name: "Arturo",
  meaning: "Bear",
  letter: "A"
}, {
  name: "Asa",
  meaning: "Healer",
  letter: "A"
}, {
  name: "Asher",
  meaning: "Happy, blessed",
  letter: "A"
}, {
  name: "Ashton",
  meaning: "Ash trees settlement",
  letter: "A"
}, {
  name: "Atlas",
  meaning: "To carry",
  letter: "A"
}, {
  name: "Atticus",
  meaning: "Man of Attica",
  letter: "A"
}, {
  name: "August",
  meaning: "Great, magnificent",
  letter: "A"
}, {
  name: "Augustus",
  meaning: "Majestic",
  letter: "A"
}, {
  name: "Austin",
  meaning: "Great, magnificent",
  letter: "A"
}, {
  name: "Axel",
  meaning: "Father of peace",
  letter: "A"
}, {
  name: "Axton",
  meaning: "Sword stone",
  letter: "A"
}, {
  name: "Baker",
  meaning: "Bread maker",
  letter: "B"
}, {
  name: "Balin",
  meaning: "Mighty soldier",
  letter: "B"
}, {
  name: "Balthazar",
  meaning: "Bel protects the King",
  letter: "B"
}, {
  name: "Bane",
  meaning: "Glorious child",
  letter: "B"
}, {
  name: "Barclay",
  meaning: "Birch tree meadow",
  letter: "B"
}, {
  name: "Barnaby",
  meaning: "Son of consolation",
  letter: "B"
}, {
  name: "Baron",
  meaning: "Young warrior",
  letter: "B"
}, {
  name: "Barrett",
  meaning: "Bear strength",
  letter: "B"
}, {
  name: "Barron",
  meaning: "Noble man",
  letter: "B"
}, {
  name: "Barry",
  meaning: "Fair-haired",
  letter: "B"
}, {
  name: "Bartholomew",
  meaning: "Son of Talmai",
  letter: "B"
}, {
  name: "Basil",
  meaning: "Royal, kingly",
  letter: "B"
}, {
  name: "Baxter",
  meaning: "Baker",
  letter: "B"
}, {
  name: "Baylor",
  meaning: "One who delivers goods",
  letter: "B"
}, {
  name: "Bear",
  meaning: "Strong, brave animal",
  letter: "B"
}, {
  name: "Beau",
  meaning: "Handsome",
  letter: "B"
}, {
  name: "Beck",
  meaning: "Brook",
  letter: "B"
}, {
  name: "Beckett",
  meaning: "Bee cottage",
  letter: "B"
}, {
  name: "Beckham",
  meaning: "Homestead by the stream",
  letter: "B"
}, {
  name: "Belen",
  meaning: "Bethlehem",
  letter: "B"
}, {
  name: "Bellamy",
  meaning: "Fine friend",
  letter: "B"
}, {
  name: "Benedict",
  meaning: "Blessed",
  letter: "B"
}, {
  name: "Benjamin",
  meaning: "Son of the right hand",
  letter: "B"
}, {
  name: "Bennett",
  meaning: "Blessed",
  letter: "B"
}, {
  name: "Benny",
  meaning: "Son of the right hand",
  letter: "B"
}, {
  name: "Benson",
  meaning: "Son of Ben",
  letter: "B"
}, {
  name: "Bentley",
  meaning: "Meadow with coarse grass",
  letter: "B"
}, {
  name: "Benton",
  meaning: "Bent grass settlement",
  letter: "B"
}, {
  name: "Bernard",
  meaning: "Brave as a bear",
  letter: "B"
}, {
  name: "Bertram",
  meaning: "Bright raven",
  letter: "B"
}, {
  name: "Bevan",
  meaning: "Son of Evan",
  letter: "B"
}, {
  name: "Bill",
  meaning: "Resolute protector",
  letter: "B"
}, {
  name: "Billy",
  meaning: "Resolute protector",
  letter: "B"
}, {
  name: "Bishop",
  meaning: "Overseer",
  letter: "B"
}, {
  name: "Bjorn",
  meaning: "Bear",
  letter: "B"
}, {
  name: "Blaine",
  meaning: "Slender",
  letter: "B"
}, {
  name: "Blaise",
  meaning: "Lisping",
  letter: "B"
}, {
  name: "Blake",
  meaning: "Fair-haired or dark",
  letter: "B"
}, {
  name: "Blaze",
  meaning: "Fire",
  letter: "B"
}, {
  name: "Bo",
  meaning: "To live",
  letter: "B"
}, {
  name: "Boden",
  meaning: "Shelter",
  letter: "B"
}, {
  name: "Bodhi",
  meaning: "Enlightenment",
  letter: "B"
}, {
  name: "Boone",
  meaning: "Blessing",
  letter: "B"
}, {
  name: "Boris",
  meaning: "Wolf",
  letter: "B"
}, {
  name: "Boston",
  meaning: "Town by the woods",
  letter: "B"
}, {
  name: "Bowen",
  meaning: "Son of Owen",
  letter: "B"
}, {
  name: "Bowie",
  meaning: "Yellow-haired",
  letter: "B"
}, {
  name: "Boyd",
  meaning: "Yellow-haired",
  letter: "B"
}, {
  name: "Braden",
  meaning: "Salmon",
  letter: "B"
}, {
  name: "Bradley",
  meaning: "Broad meadow",
  letter: "B"
}, {
  name: "Brady",
  meaning: "Spirited",
  letter: "B"
}, {
  name: "Braxton",
  meaning: "Brock's town",
  letter: "B"
}, {
  name: "Brayden",
  meaning: "Brave",
  letter: "B"
}, {
  name: "Brecken",
  meaning: "Freckled",
  letter: "B"
}, {
  name: "Brendan",
  meaning: "Prince",
  letter: "B"
}, {
  name: "Brennan",
  meaning: "Descendant of Braonán",
  letter: "B"
}, {
  name: "Brent",
  meaning: "Hill",
  letter: "B"
}, {
  name: "Brett",
  meaning: "From Brittany",
  letter: "B"
}, {
  name: "Brian",
  meaning: "Noble, strong",
  letter: "B"
}, {
  name: "Bridger",
  meaning: "Lives near a bridge",
  letter: "B"
}, {
  name: "Briggs",
  meaning: "Bridges",
  letter: "B"
}, {
  name: "Brighton",
  meaning: "Bright town",
  letter: "B"
}, {
  name: "Brock",
  meaning: "Badger",
  letter: "B"
}, {
  name: "Brodie",
  meaning: "Ditch",
  letter: "B"
}, {
  name: "Brody",
  meaning: "Ditch",
  letter: "B"
}, {
  name: "Bronson",
  meaning: "Son of the brown man",
  letter: "B"
}, {
  name: "Brooks",
  meaning: "Of the brook",
  letter: "B"
}, {
  name: "Bruce",
  meaning: "From the brushwood thicket",
  letter: "B"
}, {
  name: "Bruno",
  meaning: "Brown",
  letter: "B"
}, {
  name: "Bryan",
  meaning: "High, noble",
  letter: "B"
}, {
  name: "Bryant",
  meaning: "Strong",
  letter: "B"
}, {
  name: "Bryce",
  meaning: "Speckled",
  letter: "B"
}, {
  name: "Bryson",
  meaning: "Son of Brice",
  letter: "B"
}, {
  name: "Byron",
  meaning: "At the byres or barn",
  letter: "B"
}, {
  name: "Cade",
  meaning: "Round, barrel",
  letter: "C"
}, {
  name: "Caden",
  meaning: "Spirit of battle",
  letter: "C"
}, {
  name: "Caiden",
  meaning: "Companion",
  letter: "C"
}, {
  name: "Cain",
  meaning: "Acquired",
  letter: "C"
}, {
  name: "Cairo",
  meaning: "Victorious",
  letter: "C"
}, {
  name: "Cal",
  meaning: "Devotion",
  letter: "C"
}, {
  name: "Caleb",
  meaning: "Devotion to God",
  letter: "C"
}, {
  name: "Callahan",
  meaning: "Bright-headed",
  letter: "C"
}, {
  name: "Callan",
  meaning: "Battle, rock",
  letter: "C"
}, {
  name: "Callum",
  meaning: "Dove",
  letter: "C"
}, {
  name: "Calvin",
  meaning: "Bald",
  letter: "C"
}, {
  name: "Camden",
  meaning: "Winding valley",
  letter: "C"
}, {
  name: "Cameron",
  meaning: "Crooked nose",
  letter: "C"
}, {
  name: "Camilo",
  meaning: "Young ceremonial attendant",
  letter: "C"
}, {
  name: "Campbell",
  meaning: "Crooked mouth",
  letter: "C"
}, {
  name: "Cannon",
  meaning: "Clergyman",
  letter: "C"
}, {
  name: "Carl",
  meaning: "Free man",
  letter: "C"
}, {
  name: "Carlos",
  meaning: "Free man",
  letter: "C"
}, {
  name: "Carlton",
  meaning: "Town of free men",
  letter: "C"
}, {
  name: "Carmelo",
  meaning: "Garden",
  letter: "C"
}, {
  name: "Carson",
  meaning: "Son of Carr",
  letter: "C"
}, {
  name: "Carter",
  meaning: "Cart driver",
  letter: "C"
}, {
  name: "Case",
  meaning: "Box",
  letter: "C"
}, {
  name: "Casen",
  meaning: "Pure",
  letter: "C"
}, {
  name: "Casey",
  meaning: "Vigilant",
  letter: "C"
}, {
  name: "Cash",
  meaning: "Hollow",
  letter: "C"
}, {
  name: "Caspian",
  meaning: "From the Caspian Sea",
  letter: "C"
}, {
  name: "Cassian",
  meaning: "Hollow",
  letter: "C"
}, {
  name: "Cassius",
  meaning: "Hollow",
  letter: "C"
}, {
  name: "Castiel",
  meaning: "My shield is God",
  letter: "C"
}, {
  name: "Castor",
  meaning: "Beaver",
  letter: "C"
}, {
  name: "Cato",
  meaning: "Wise",
  letter: "C"
}, {
  name: "Cavan",
  meaning: "Handsome",
  letter: "C"
}, {
  name: "Cayden",
  meaning: "Fighter",
  letter: "C"
}, {
  name: "Cecil",
  meaning: "Blind",
  letter: "C"
}, {
  name: "Cedric",
  meaning: "Bounty",
  letter: "C"
}, {
  name: "Cesar",
  meaning: "Hairy",
  letter: "C"
}, {
  name: "Chad",
  meaning: "Battle",
  letter: "C"
}, {
  name: "Chaim",
  meaning: "Life",
  letter: "C"
}, {
  name: "Chance",
  meaning: "Good fortune",
  letter: "C"
}, {
  name: "Chandler",
  meaning: "Candle maker",
  letter: "C"
}, {
  name: "Charles",
  meaning: "Free man",
  letter: "C"
}, {
  name: "Charlie",
  meaning: "Free man",
  letter: "C"
}, {
  name: "Chase",
  meaning: "To hunt",
  letter: "C"
}, {
  name: "Chatham",
  meaning: "Soldier's settlement",
  letter: "C"
}, {
  name: "Chauncey",
  meaning: "Chancellor",
  letter: "C"
}, {
  name: "Chester",
  meaning: "Fortress",
  letter: "C"
}, {
  name: "Chris",
  meaning: "Bearer of Christ",
  letter: "C"
}, {
  name: "Christian",
  meaning: "Follower of Christ",
  letter: "C"
}, {
  name: "Christopher",
  meaning: "Bearer of Christ",
  letter: "C"
}, {
  name: "Cian",
  meaning: "Ancient",
  letter: "C"
}, {
  name: "Clarence",
  meaning: "Bright",
  letter: "C"
}, {
  name: "Clark",
  meaning: "Scribe",
  letter: "C"
}, {
  name: "Claude",
  meaning: "Limping",
  letter: "C"
}, {
  name: "Clay",
  meaning: "Earth",
  letter: "C"
}, {
  name: "Clayton",
  meaning: "Settlement on clay land",
  letter: "C"
}, {
  name: "Clement",
  meaning: "Merciful",
  letter: "C"
}, {
  name: "Cliff",
  meaning: "Ford near a cliff",
  letter: "C"
}, {
  name: "Clifford",
  meaning: "Ford near a cliff",
  letter: "C"
}, {
  name: "Clifton",
  meaning: "Settlement near a cliff",
  letter: "C"
}, {
  name: "Clint",
  meaning: "Settlement on a hill",
  letter: "C"
}, {
  name: "Clinton",
  meaning: "Settlement on a hill",
  letter: "C"
}, {
  name: "Clive",
  meaning: "Cliff",
  letter: "C"
}, {
  name: "Clyde",
  meaning: "Warm",
  letter: "C"
}, {
  name: "Coby",
  meaning: "Supplanter",
  letter: "C"
}, {
  name: "Cody",
  meaning: "Helpful",
  letter: "C"
}, {
  name: "Cohen",
  meaning: "Priest",
  letter: "C"
}, {
  name: "Colby",
  meaning: "Coal town",
  letter: "C"
}, {
  name: "Cole",
  meaning: "Swarthy, coal black",
  letter: "C"
}, {
  name: "Coleman",
  meaning: "Charcoal burner",
  letter: "C"
}, {
  name: "Colin",
  meaning: "Pup",
  letter: "C"
}, {
  name: "Collier",
  meaning: "Coal miner",
  letter: "C"
}, {
  name: "Collin",
  meaning: "Young dog",
  letter: "C"
}, {
  name: "Colm",
  meaning: "Dove",
  letter: "C"
}, {
  name: "Colt",
  meaning: "Young horse",
  letter: "C"
}, {
  name: "Colten",
  meaning: "Coal town",
  letter: "C"
}, {
  name: "Colter",
  meaning: "Colt-herd",
  letter: "C"
}, {
  name: "Colton",
  meaning: "Coal town",
  letter: "C"
}, {
  name: "Conan",
  meaning: "Little wolf",
  letter: "C"
}, {
  name: "Connor",
  meaning: "Lover of hounds",
  letter: "C"
}, {
  name: "Conrad",
  meaning: "Brave counsel",
  letter: "C"
}, {
  name: "Constantine",
  meaning: "Steadfast",
  letter: "C"
}, {
  name: "Cooper",
  meaning: "Barrel maker",
  letter: "C"
}, {
  name: "Corbin",
  meaning: "Raven",
  letter: "C"
}, {
  name: "Corey",
  meaning: "From the hollow",
  letter: "C"
}, {
  name: "Cormac",
  meaning: "Charioteer",
  letter: "C"
}, {
  name: "Cornelius",
  meaning: "Horn",
  letter: "C"
}, {
  name: "Cortez",
  meaning: "Courteous",
  letter: "C"
}, {
  name: "Cory",
  meaning: "From the hollow",
  letter: "C"
}, {
  name: "Cosmo",
  meaning: "Order, beauty",
  letter: "C"
}, {
  name: "Craig",
  meaning: "Rock",
  letter: "C"
}, {
  name: "Crew",
  meaning: "Group of people",
  letter: "C"
}, {
  name: "Crispin",
  meaning: "Curly-haired",
  letter: "C"
}, {
  name: "Crosby",
  meaning: "Village with crosses",
  letter: "C"
}, {
  name: "Cruz",
  meaning: "Cross",
  letter: "C"
}, {
  name: "Cullen",
  meaning: "Holly",
  letter: "C"
}, {
  name: "Curtis",
  meaning: "Courteous",
  letter: "C"
}, {
  name: "Cyrus",
  meaning: "Sun",
  letter: "C"
}, {
  name: "Dagur",
  meaning: "Day",
  letter: "D"
}, {
  name: "Dakota",
  meaning: "Friendly",
  letter: "D"
}, {
  name: "Dale",
  meaning: "Valley",
  letter: "D"
}, {
  name: "Dallas",
  meaning: "From the dales",
  letter: "D"
}, {
  name: "Dalton",
  meaning: "Valley town",
  letter: "D"
}, {
  name: "Damian",
  meaning: "To tame",
  letter: "D"
}, {
  name: "Damien",
  meaning: "To tame",
  letter: "D"
}, {
  name: "Damon",
  meaning: "To tame",
  letter: "D"
}, {
  name: "Dan",
  meaning: "God is my judge",
  letter: "D"
}, {
  name: "Dane",
  meaning: "From Denmark",
  letter: "D"
}, {
  name: "Daniel",
  meaning: "God is my judge",
  letter: "D"
}, {
  name: "Danny",
  meaning: "God is my judge",
  letter: "D"
}, {
  name: "Dante",
  meaning: "Enduring",
  letter: "D"
}, {
  name: "Dara",
  meaning: "Oak tree",
  letter: "D"
}, {
  name: "Darby",
  meaning: "Deer park",
  letter: "D"
}, {
  name: "Darcy",
  meaning: "From Arcy",
  letter: "D"
}, {
  name: "Darian",
  meaning: "Gift",
  letter: "D"
}, {
  name: "Darius",
  meaning: "Possessing goodness",
  letter: "D"
}, {
  name: "Darnell",
  meaning: "Hidden nook",
  letter: "D"
}, {
  name: "Darrel",
  meaning: "Beloved",
  letter: "D"
}, {
  name: "Darren",
  meaning: "Great",
  letter: "D"
}, {
  name: "Darrin",
  meaning: "Great",
  letter: "D"
}, {
  name: "Darryl",
  meaning: "Beloved",
  letter: "D"
}, {
  name: "Darwin",
  meaning: "Dear friend",
  letter: "D"
}, {
  name: "Dash",
  meaning: "From the ash",
  letter: "D"
}, {
  name: "Dashiell",
  meaning: "Page boy",
  letter: "D"
}, {
  name: "Dave",
  meaning: "Beloved",
  letter: "D"
}, {
  name: "David",
  meaning: "Beloved",
  letter: "D"
}, {
  name: "Davin",
  meaning: "Beloved",
  letter: "D"
}, {
  name: "Davis",
  meaning: "Son of David",
  letter: "D"
}, {
  name: "Dawson",
  meaning: "Son of David",
  letter: "D"
}, {
  name: "Dax",
  meaning: "Water",
  letter: "D"
}, {
  name: "Daxton",
  meaning: "From Dax",
  letter: "D"
}, {
  name: "Dayton",
  meaning: "Bright town",
  letter: "D"
}, {
  name: "Deacon",
  meaning: "Messenger",
  letter: "D"
}, {
  name: "Dean",
  meaning: "Valley",
  letter: "D"
}, {
  name: "Deandre",
  meaning: "Manly",
  letter: "D"
}, {
  name: "Declan",
  meaning: "Man of prayer",
  letter: "D"
}, {
  name: "Demetrius",
  meaning: "Follower of Demeter",
  letter: "D"
}, {
  name: "Denis",
  meaning: "Follower of Dionysus",
  letter: "D"
}, {
  name: "Dennis",
  meaning: "Follower of Dionysus",
  letter: "D"
}, {
  name: "Denver",
  meaning: "Green valley",
  letter: "D"
}, {
  name: "Denzel",
  meaning: "From the high stronghold",
  letter: "D"
}, {
  name: "Derek",
  meaning: "People's ruler",
  letter: "D"
}, {
  name: "Dermot",
  meaning: "Free man",
  letter: "D"
}, {
  name: "Derrick",
  meaning: "People's ruler",
  letter: "D"
}, {
  name: "Desmond",
  meaning: "From South Munster",
  letter: "D"
}, {
  name: "Devin",
  meaning: "Poet",
  letter: "D"
}, {
  name: "Devon",
  meaning: "Deep valley dweller",
  letter: "D"
}, {
  name: "Dexter",
  meaning: "Right-handed",
  letter: "D"
}, {
  name: "Diego",
  meaning: "Supplanter",
  letter: "D"
}, {
  name: "Dillon",
  meaning: "Like a lion",
  letter: "D"
}, {
  name: "Dimitri",
  meaning: "Follower of Demeter",
  letter: "D"
}, {
  name: "Dion",
  meaning: "Follower of Dionysus",
  letter: "D"
}, {
  name: "Dirk",
  meaning: "People's ruler",
  letter: "D"
}, {
  name: "Dominic",
  meaning: "Belonging to the Lord",
  letter: "D"
}, {
  name: "Dominick",
  meaning: "Belonging to the Lord",
  letter: "D"
}, {
  name: "Don",
  meaning: "World ruler",
  letter: "D"
}, {
  name: "Donald",
  meaning: "World ruler",
  letter: "D"
}, {
  name: "Donovan",
  meaning: "Dark-haired chieftain",
  letter: "D"
}, {
  name: "Dorian",
  meaning: "Of the sea",
  letter: "D"
}, {
  name: "Douglas",
  meaning: "Dark stream",
  letter: "D"
}, {
  name: "Drake",
  meaning: "Dragon",
  letter: "D"
}, {
  name: "Drew",
  meaning: "Strong and manly",
  letter: "D"
}, {
  name: "Duke",
  meaning: "Leader",
  letter: "D"
}, {
  name: "Duncan",
  meaning: "Dark warrior",
  letter: "D"
}, {
  name: "Dustin",
  meaning: "Thor's stone",
  letter: "D"
}, {
  name: "Dwayne",
  meaning: "Little dark one",
  letter: "D"
}, {
  name: "Dwight",
  meaning: "White or blonde",
  letter: "D"
}, {
  name: "Dylan",
  meaning: "Son of the sea",
  letter: "D"
}, {
  name: "Earl",
  meaning: "Noble leader",
  letter: "E"
}, {
  name: "Easton",
  meaning: "East town",
  letter: "E"
}, {
  name: "Eaton",
  meaning: "Island settlement",
  letter: "E"
}, {
  name: "Eben",
  meaning: "Stone",
  letter: "E"
}, {
  name: "Ebenezer",
  meaning: "Stone of help",
  letter: "E"
}, {
  name: "Edan",
  meaning: "Little fire",
  letter: "E"
}, {
  name: "Eddie",
  meaning: "Wealthy guardian",
  letter: "E"
}, {
  name: "Eden",
  meaning: "Place of pleasure",
  letter: "E"
}, {
  name: "Edgar",
  meaning: "Wealthy spearman",
  letter: "E"
}, {
  name: "Edison",
  meaning: "Son of Edward",
  letter: "E"
}, {
  name: "Edmund",
  meaning: "Wealthy protector",
  letter: "E"
}, {
  name: "Edric",
  meaning: "Wealthy ruler",
  letter: "E"
}, {
  name: "Edward",
  meaning: "Wealthy guardian",
  letter: "E"
}, {
  name: "Edwin",
  meaning: "Wealthy friend",
  letter: "E"
}, {
  name: "Egan",
  meaning: "Little fire",
  letter: "E"
}, {
  name: "Egbert",
  meaning: "Bright edge",
  letter: "E"
}, {
  name: "Eian",
  meaning: "God is gracious",
  letter: "E"
}, {
  name: "Eisley",
  meaning: "Cheerful",
  letter: "E"
}, {
  name: "Elan",
  meaning: "Tree",
  letter: "E"
}, {
  name: "Elder",
  meaning: "Older",
  letter: "E"
}, {
  name: "Eldon",
  meaning: "Ella's hill",
  letter: "E"
}, {
  name: "Eli",
  meaning: "Ascended",
  letter: "E"
}, {
  name: "Elian",
  meaning: "The shining light",
  letter: "E",
  url: "https://shulisnameshub.com/elian-name-meaning-origin-and-popularity/"
}, {
  name: "Elias",
  meaning: "Yahweh is God",
  letter: "E"
}, {
  name: "Elijah",
  meaning: "Yahweh is God",
  letter: "E"
}, {
  name: "Eliot",
  meaning: "Jehovah is God",
  letter: "E"
}, {
  name: "Elisha",
  meaning: "God is my salvation",
  letter: "E"
}, {
  name: "Ellery",
  meaning: "Cheerful",
  letter: "E"
}, {
  name: "Ellington",
  meaning: "Ellis's town",
  letter: "E"
}, {
  name: "Elliot",
  meaning: "Jehovah is God",
  letter: "E"
}, {
  name: "Elliott",
  meaning: "Jehovah is God",
  letter: "E"
}, {
  name: "Ellis",
  meaning: "Benevolent",
  letter: "E"
}, {
  name: "Ellison",
  meaning: "Son of Ellis",
  letter: "E"
}, {
  name: "Elmer",
  meaning: "Noble and famous",
  letter: "E"
}, {
  name: "Elmo",
  meaning: "Protector",
  letter: "E"
}, {
  name: "Elon",
  meaning: "Oak tree",
  letter: "E"
}, {
  name: "Elroy",
  meaning: "The king",
  letter: "E"
}, {
  name: "Elton",
  meaning: "Ella's town",
  letter: "E"
}, {
  name: "Elvis",
  meaning: "All-wise",
  letter: "E"
}, {
  name: "Elwood",
  meaning: "Elder tree wood",
  letter: "E"
}, {
  name: "Emanuel",
  meaning: "God is with us",
  letter: "E"
}, {
  name: "Emerson",
  meaning: "Son of Emery",
  letter: "E"
}, {
  name: "Emery",
  meaning: "Industrious",
  letter: "E"
}, {
  name: "Emil",
  meaning: "Rival",
  letter: "E"
}, {
  name: "Emiliano",
  meaning: "Rival",
  letter: "E"
}, {
  name: "Emilio",
  meaning: "Rival",
  letter: "E"
}, {
  name: "Emlyn",
  meaning: "Waterfall",
  letter: "E"
}, {
  name: "Emmanuel",
  meaning: "God is with us",
  letter: "E"
}, {
  name: "Emmet",
  meaning: "Universal",
  letter: "E"
}, {
  name: "Emmett",
  meaning: "Universal",
  letter: "E"
}, {
  name: "Emory",
  meaning: "Industrious",
  letter: "E"
}, {
  name: "Enoch",
  meaning: "Dedicated",
  letter: "E"
}, {
  name: "Enos",
  meaning: "Mankind",
  letter: "E"
}, {
  name: "Enrico",
  meaning: "Home ruler",
  letter: "E"
}, {
  name: "Enrique",
  meaning: "Home ruler",
  letter: "E"
}, {
  name: "Enzo",
  meaning: "Home ruler",
  letter: "E"
}, {
  name: "Ephraim",
  meaning: "Fruitful",
  letter: "E"
}, {
  name: "Erasmus",
  meaning: "Beloved",
  letter: "E"
}, {
  name: "Eric",
  meaning: "Eternal ruler",
  letter: "E"
}, {
  name: "Erick",
  meaning: "Eternal ruler",
  letter: "E"
}, {
  name: "Erik",
  meaning: "Eternal ruler",
  letter: "E"
}, {
  name: "Ernest",
  meaning: "Serious",
  letter: "E"
}, {
  name: "Ernesto",
  meaning: "Serious",
  letter: "E"
}, {
  name: "Ernie",
  meaning: "Serious",
  letter: "E"
}, {
  name: "Errol",
  meaning: "Earl",
  letter: "E"
}, {
  name: "Ervin",
  meaning: "Sea friend",
  letter: "E"
}, {
  name: "Erwin",
  meaning: "Boar friend",
  letter: "E"
}, {
  name: "Esau",
  meaning: "Hairy",
  letter: "E"
}, {
  name: "Esmond",
  meaning: "Grace protection",
  letter: "E"
}, {
  name: "Esteban",
  meaning: "Crown",
  letter: "E"
}, {
  name: "Ethan",
  meaning: "Strong, firm",
  letter: "E"
}, {
  name: "Ethelbert",
  meaning: "Noble bright",
  letter: "E"
}, {
  name: "Etienne",
  meaning: "Crown",
  letter: "E"
}, {
  name: "Euan",
  meaning: "Born of the yew tree",
  letter: "E"
}, {
  name: "Eugene",
  meaning: "Well-born",
  letter: "E"
}, {
  name: "Eustace",
  meaning: "Fruitful",
  letter: "E"
}, {
  name: "Evan",
  meaning: "God is gracious",
  letter: "E"
}, {
  name: "Evander",
  meaning: "Good man",
  letter: "E"
}, {
  name: "Everard",
  meaning: "Brave as a boar",
  letter: "E"
}, {
  name: "Everett",
  meaning: "Brave as a wild boar",
  letter: "E"
}, {
  name: "Everley",
  meaning: "Boar meadow",
  letter: "E"
}, {
  name: "Ewan",
  meaning: "Born of the yew tree",
  letter: "E"
}, {
  name: "Ezekiel",
  meaning: "God strengthens",
  letter: "E"
}, {
  name: "Ezra",
  meaning: "Help",
  letter: "E"
}, {
  name: "Fabian",
  meaning: "Bean grower",
  letter: "F"
}, {
  name: "Fabio",
  meaning: "Bean grower",
  letter: "F"
}, {
  name: "Falcon",
  meaning: "Bird of prey",
  letter: "F"
}, {
  name: "Farley",
  meaning: "Fern meadow",
  letter: "F"
}, {
  name: "Farrell",
  meaning: "Brave",
  letter: "F"
}, {
  name: "Faust",
  meaning: "Lucky",
  letter: "F"
}, {
  name: "Felix",
  meaning: "Happy, fortunate",
  letter: "F"
}, {
  name: "Fenton",
  meaning: "Marsh town",
  letter: "F"
}, {
  name: "Ferdinand",
  meaning: "Bold voyager",
  letter: "F"
}, {
  name: "Fergus",
  meaning: "Man of vigor",
  letter: "F"
}, {
  name: "Ferguson",
  meaning: "Son of Fergus",
  letter: "F"
}, {
  name: "Fernand",
  meaning: "Bold voyager",
  letter: "F"
}, {
  name: "Fernando",
  meaning: "Bold voyager",
  letter: "F"
}, {
  name: "Ferris",
  meaning: "Iron worker",
  letter: "F"
}, {
  name: "Fidel",
  meaning: "Faithful",
  letter: "F"
}, {
  name: "Fielding",
  meaning: "Field worker",
  letter: "F"
}, {
  name: "Fillmore",
  meaning: "Very famous",
  letter: "F"
}, {
  name: "Finbar",
  meaning: "Fair-haired",
  letter: "F"
}, {
  name: "Finlay",
  meaning: "Fair-haired hero",
  letter: "F"
}, {
  name: "Finley",
  meaning: "Fair-haired hero",
  letter: "F"
}, {
  name: "Finn",
  meaning: "Fair or white",
  letter: "F"
}, {
  name: "Finnegan",
  meaning: "Fair",
  letter: "F"
}, {
  name: "Finnian",
  meaning: "Fair",
  letter: "F"
}, {
  name: "Fintan",
  meaning: "White fire",
  letter: "F"
}, {
  name: "Fisher",
  meaning: "Fisherman",
  letter: "F"
}, {
  name: "Fitz",
  meaning: "Son of",
  letter: "F"
}, {
  name: "Fitzgerald",
  meaning: "Son of Gerald",
  letter: "F"
}, {
  name: "Fitzhugh",
  meaning: "Son of Hugh",
  letter: "F"
}, {
  name: "Fitzpatrick",
  meaning: "Son of Patrick",
  letter: "F"
}, {
  name: "Fitzroy",
  meaning: "Son of the king",
  letter: "F"
}, {
  name: "Flannery",
  meaning: "Red-haired",
  letter: "F"
}, {
  name: "Flavian",
  meaning: "Yellow",
  letter: "F"
}, {
  name: "Fletcher",
  meaning: "Arrow-maker",
  letter: "F"
}, {
  name: "Flint",
  meaning: "Hard rock",
  letter: "F"
}, {
  name: "Floyd",
  meaning: "Gray-haired",
  letter: "F"
}, {
  name: "Flynn",
  meaning: "Son of the red-haired one",
  letter: "F"
}, {
  name: "Forbes",
  meaning: "Field",
  letter: "F"
}, {
  name: "Ford",
  meaning: "River crossing",
  letter: "F"
}, {
  name: "Forest",
  meaning: "Woods",
  letter: "F"
}, {
  name: "Forester",
  meaning: "Woods worker",
  letter: "F"
}, {
  name: "Forrest",
  meaning: "Woods",
  letter: "F"
}, {
  name: "Foster",
  meaning: "Forester",
  letter: "F"
}, {
  name: "Fowler",
  meaning: "Bird catcher",
  letter: "F"
}, {
  name: "Fox",
  meaning: "Wild animal",
  letter: "F"
}, {
  name: "Francesco",
  meaning: "Free man",
  letter: "F"
}, {
  name: "Francis",
  meaning: "Free man",
  letter: "F"
}, {
  name: "Francisco",
  meaning: "Free man",
  letter: "F"
}, {
  name: "Frank",
  meaning: "Free man",
  letter: "F"
}, {
  name: "Frankie",
  meaning: "Free man",
  letter: "F"
}, {
  name: "Franklin",
  meaning: "Free landholder",
  letter: "F"
}, {
  name: "Fraser",
  meaning: "Strawberry",
  letter: "F"
}, {
  name: "Fred",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Freddie",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Freddy",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Frederic",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Frederick",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Fredrick",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Free",
  meaning: "Not bound",
  letter: "F"
}, {
  name: "Freeman",
  meaning: "Free man",
  letter: "F"
}, {
  name: "Fritz",
  meaning: "Peaceful ruler",
  letter: "F"
}, {
  name: "Fulton",
  meaning: "Bird-catcher's town",
  letter: "F"
}, {
  name: "Gabe",
  meaning: "God is my strength",
  letter: "G"
}, {
  name: "Gabriel",
  meaning: "God is my strength",
  letter: "G"
}, {
  name: "Gael",
  meaning: "Gaelic",
  letter: "G"
}, {
  name: "Gage",
  meaning: "Pledge",
  letter: "G"
}, {
  name: "Gaige",
  meaning: "Pledge",
  letter: "G"
}, {
  name: "Gale",
  meaning: "Cheerful",
  letter: "G"
}, {
  name: "Galen",
  meaning: "Calm",
  letter: "G"
}, {
  name: "Gallagher",
  meaning: "Foreign helper",
  letter: "G"
}, {
  name: "Gannon",
  meaning: "Fair-skinned",
  letter: "G"
}, {
  name: "Gareth",
  meaning: "Gentle",
  letter: "G"
}, {
  name: "Garret",
  meaning: "Spear strength",
  letter: "G"
}, {
  name: "Garrett",
  meaning: "Spear strength",
  letter: "G"
}, {
  name: "Garrick",
  meaning: "Spear ruler",
  letter: "G"
}, {
  name: "Garrison",
  meaning: "Spear-fortified town",
  letter: "G"
}, {
  name: "Garry",
  meaning: "Spear ruler",
  letter: "G"
}, {
  name: "Garth",
  meaning: "Garden",
  letter: "G"
}, {
  name: "Gary",
  meaning: "Spear ruler",
  letter: "G"
}, {
  name: "Gaspard",
  meaning: "Treasurer",
  letter: "G"
}, {
  name: "Gaston",
  meaning: "Guest",
  letter: "G"
}, {
  name: "Gavin",
  meaning: "White hawk",
  letter: "G"
}, {
  name: "Gene",
  meaning: "Well-born",
  letter: "G"
}, {
  name: "Geoffrey",
  meaning: "Peace of God",
  letter: "G"
}, {
  name: "George",
  meaning: "Farmer",
  letter: "G"
}, {
  name: "Gerald",
  meaning: "Ruler with a spear",
  letter: "G"
}, {
  name: "Gerard",
  meaning: "Spear brave",
  letter: "G"
}, {
  name: "Gerardo",
  meaning: "Spear brave",
  letter: "G"
}, {
  name: "Gerry",
  meaning: "Spear ruler",
  letter: "G"
}, {
  name: "Giacomo",
  meaning: "Supplanter",
  letter: "G"
}, {
  name: "Gian",
  meaning: "God is gracious",
  letter: "G"
}, {
  name: "Gianni",
  meaning: "God is gracious",
  letter: "G"
}, {
  name: "Gibson",
  meaning: "Son of Gilbert",
  letter: "G"
}, {
  name: "Gideon",
  meaning: "Great destroyer",
  letter: "G"
}, {
  name: "Gilbert",
  meaning: "Bright pledge",
  letter: "G"
}, {
  name: "Gilberto",
  meaning: "Bright pledge",
  letter: "G"
}, {
  name: "Giles",
  meaning: "Young goat",
  letter: "G"
}, {
  name: "Gino",
  meaning: "Well-born",
  letter: "G"
}, {
  name: "Giovanni",
  meaning: "God is gracious",
  letter: "G"
}, {
  name: "Glen",
  meaning: "Valley",
  letter: "G"
}, {
  name: "Glenn",
  meaning: "Valley",
  letter: "G"
}, {
  name: "Godfrey",
  meaning: "God's peace",
  letter: "G"
}, {
  name: "Gordon",
  meaning: "Spacious fort",
  letter: "G"
}, {
  name: "Grady",
  meaning: "Noble",
  letter: "G"
}, {
  name: "Graham",
  meaning: "Gravelly homestead",
  letter: "G"
}, {
  name: "Grant",
  meaning: "Large",
  letter: "G"
}, {
  name: "Gray",
  meaning: "Gray-haired",
  letter: "G"
}, {
  name: "Grayson",
  meaning: "Son of the gray-haired one",
  letter: "G"
}, {
  name: "Greg",
  meaning: "Watchful",
  letter: "G"
}, {
  name: "Gregg",
  meaning: "Watchful",
  letter: "G"
}, {
  name: "Gregory",
  meaning: "Watchful",
  letter: "G"
}, {
  name: "Grey",
  meaning: "Gray-haired",
  letter: "G"
}, {
  name: "Greyson",
  meaning: "Son of the gray-haired one",
  letter: "G"
}, {
  name: "Griffin",
  meaning: "Strong lord",
  letter: "G"
}, {
  name: "Griffith",
  meaning: "Strong lord",
  letter: "G"
}, {
  name: "Grover",
  meaning: "Grove dweller",
  letter: "G"
}, {
  name: "Guillermo",
  meaning: "Resolute protector",
  letter: "G"
}, {
  name: "Gully",
  meaning: "From the giant's town",
  letter: "G"
}, {
  name: "Gunnar",
  meaning: "Bold warrior",
  letter: "G"
}, {
  name: "Gunner",
  meaning: "Bold warrior",
  letter: "G"
}, {
  name: "Gus",
  meaning: "Great, magnificent",
  letter: "G"
}, {
  name: "Gustav",
  meaning: "Staff of the Goths",
  letter: "G"
}, {
  name: "Gustavo",
  meaning: "Staff of the Goths",
  letter: "G"
}, {
  name: "Guy",
  meaning: "Guide",
  letter: "G"
}, {
  name: "Habib",
  meaning: "Beloved",
  letter: "H"
}, {
  name: "Hadden",
  meaning: "Heather hill",
  letter: "H"
}, {
  name: "Hadley",
  meaning: "Heather field",
  letter: "H"
}, {
  name: "Hagan",
  meaning: "Little fire",
  letter: "H"
}, {
  name: "Hakeem",
  meaning: "Wise",
  letter: "H"
}, {
  name: "Hal",
  meaning: "Army ruler",
  letter: "H"
}, {
  name: "Hale",
  meaning: "Hero",
  letter: "H"
}, {
  name: "Hall",
  meaning: "Manor house",
  letter: "H"
}, {
  name: "Halsey",
  meaning: "Hallowed island",
  letter: "H"
}, {
  name: "Hamish",
  meaning: "Supplanter",
  letter: "H"
}, {
  name: "Hamilton",
  meaning: "Flat-topped hill",
  letter: "H"
}, {
  name: "Hamza",
  meaning: "Lion",
  letter: "H"
}, {
  name: "Hank",
  meaning: "Estate ruler",
  letter: "H"
}, {
  name: "Hans",
  meaning: "God is gracious",
  letter: "H"
}, {
  name: "Harlan",
  meaning: "Rocky land",
  letter: "H"
}, {
  name: "Harland",
  meaning: "Rocky land",
  letter: "H"
}, {
  name: "Harley",
  meaning: "Hare's meadow",
  letter: "H"
}, {
  name: "Harlow",
  meaning: "Army hill",
  letter: "H"
}, {
  name: "Harold",
  meaning: "Army ruler",
  letter: "H"
}, {
  name: "Harper",
  meaning: "Harp player",
  letter: "H"
}, {
  name: "Harris",
  meaning: "Son of Harry",
  letter: "H"
}, {
  name: "Harrison",
  meaning: "Son of Harry",
  letter: "H"
}, {
  name: "Harry",
  meaning: "Estate ruler",
  letter: "H"
}, {
  name: "Harvey",
  meaning: "Battle worthy",
  letter: "H"
}, {
  name: "Hassan",
  meaning: "Handsome",
  letter: "H"
}, {
  name: "Hayden",
  meaning: "Heather-grown hill",
  letter: "H"
}, {
  name: "Hayes",
  meaning: "Hedged area",
  letter: "H"
}, {
  name: "Heath",
  meaning: "Heathland dweller",
  letter: "H"
}, {
  name: "Hector",
  meaning: "Holding fast",
  letter: "H"
}, {
  name: "Hendrix",
  meaning: "Estate ruler",
  letter: "H"
}, {
  name: "Henley",
  meaning: "High meadow",
  letter: "H"
}, {
  name: "Henry",
  meaning: "Estate ruler",
  letter: "H"
}, {
  name: "Herbert",
  meaning: "Bright army",
  letter: "H"
}, {
  name: "Herman",
  meaning: "Army man",
  letter: "H"
}, {
  name: "Herschel",
  meaning: "Deer",
  letter: "H"
}, {
  name: "Hezekiah",
  meaning: "God strengthens",
  letter: "H"
}, {
  name: "Hiram",
  meaning: "Exalted brother",
  letter: "H"
}, {
  name: "Holden",
  meaning: "Hollow valley",
  letter: "H"
}, {
  name: "Hollis",
  meaning: "Holly trees",
  letter: "H"
}, {
  name: "Homer",
  meaning: "Pledge",
  letter: "H"
}, {
  name: "Horace",
  meaning: "Timekeeper",
  letter: "H"
}, {
  name: "Horatio",
  meaning: "Timekeeper",
  letter: "H"
}, {
  name: "Howard",
  meaning: "Brave heart",
  letter: "H"
}, {
  name: "Howie",
  meaning: "Brave heart",
  letter: "H"
}, {
  name: "Hubert",
  meaning: "Bright heart",
  letter: "H"
}, {
  name: "Hudson",
  meaning: "Son of Hugh",
  letter: "H"
}, {
  name: "Hugh",
  meaning: "Mind, intellect",
  letter: "H"
}, {
  name: "Hugo",
  meaning: "Mind, intellect",
  letter: "H"
}, {
  name: "Humphrey",
  meaning: "Peaceful warrior",
  letter: "H"
}, {
  name: "Hunter",
  meaning: "One who hunts",
  letter: "H"
}, {
  name: "Huxley",
  meaning: "Hugh's meadow",
  letter: "H"
}, {
  name: "Hyatt",
  meaning: "High gate",
  letter: "H"
}, {
  name: "Ian",
  meaning: "The Lord is gracious",
  letter: "I"
}, {
  name: "Ibrahim",
  meaning: "Father of many",
  letter: "I"
}, {
  name: "Ichabod",
  meaning: "The glory has departed",
  letter: "I"
}, {
  name: "Idris",
  meaning: "Studious",
  letter: "I"
}, {
  name: "Ignacio",
  meaning: "Fiery",
  letter: "I"
}, {
  name: "Ignatius",
  meaning: "Fiery",
  letter: "I"
}, {
  name: "Igor",
  meaning: "Warrior of peace",
  letter: "I"
}, {
  name: "Ike",
  meaning: "Laughter",
  letter: "I"
}, {
  name: "Iker",
  meaning: "Visitation",
  letter: "I"
}, {
  name: "Ilan",
  meaning: "Tree",
  letter: "I"
}, {
  name: "Immanuel",
  meaning: "God is with us",
  letter: "I"
}, {
  name: "Inigo",
  meaning: "Fiery",
  letter: "I"
}, {
  name: "Ira",
  meaning: "Watchful",
  letter: "I"
}, {
  name: "Irvin",
  meaning: "Green water",
  letter: "I"
}, {
  name: "Irving",
  meaning: "Green water",
  letter: "I"
}, {
  name: "Irwin",
  meaning: "Boar friend",
  letter: "I"
}, {
  name: "Isaac",
  meaning: "He will laugh",
  letter: "I"
}, {
  name: "Isai",
  meaning: "God is my salvation",
  letter: "I"
}, {
  name: "Isaiah",
  meaning: "Salvation of the Lord",
  letter: "I"
}, {
  name: "Isam",
  meaning: "Security",
  letter: "I"
}, {
  name: "Ishaan",
  meaning: "Lord Shiva",
  letter: "I"
}, {
  name: "Ishmael",
  meaning: "God will hear",
  letter: "I"
}, {
  name: "Isidore",
  meaning: "Gift of Isis",
  letter: "I"
}, {
  name: "Ismael",
  meaning: "God will hear",
  letter: "I"
}, {
  name: "Israel",
  meaning: "Wrestled with God",
  letter: "I"
}, {
  name: "Issac",
  meaning: "Laughter",
  letter: "I"
}, {
  name: "Ivan",
  meaning: "God is gracious",
  letter: "I"
}, {
  name: "Ivar",
  meaning: "Yew warrior",
  letter: "I"
}, {
  name: "Ivor",
  meaning: "Yew warrior",
  letter: "I"
}, {
  name: "Ivy",
  meaning: "Faithfulness",
  letter: "I"
}, {
  name: "Izaiah",
  meaning: "God is my salvation",
  letter: "I"
}, {
  name: "Izzy",
  meaning: "God is my salvation",
  letter: "I"
}, {
  name: "Jace",
  meaning: "Healer",
  letter: "J"
}, {
  name: "Jack",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jackson",
  meaning: "Son of Jack",
  letter: "J"
}, {
  name: "Jacob",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jacoby",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jaden",
  meaning: "God has heard",
  letter: "J"
}, {
  name: "Jagger",
  meaning: "Carter",
  letter: "J"
}, {
  name: "Jairo",
  meaning: "He enlightens",
  letter: "J"
}, {
  name: "Jake",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jakob",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jalen",
  meaning: "Calm",
  letter: "J"
}, {
  name: "James",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jameson",
  meaning: "Son of James",
  letter: "J"
}, {
  name: "Jamie",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jared",
  meaning: "Descent",
  letter: "J"
}, {
  name: "Jarrett",
  meaning: "Spear strength",
  letter: "J"
}, {
  name: "Jarvis",
  meaning: "Spear servant",
  letter: "J"
}, {
  name: "Jason",
  meaning: "Healer",
  letter: "J"
}, {
  name: "Jasper",
  meaning: "Bringer of treasure",
  letter: "J"
}, {
  name: "Javier",
  meaning: "New house",
  letter: "J"
}, {
  name: "Jax",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jaxon",
  meaning: "Son of Jack",
  letter: "J"
}, {
  name: "Jaxson",
  meaning: "Son of Jack",
  letter: "J"
}, {
  name: "Jay",
  meaning: "Victory",
  letter: "J"
}, {
  name: "Jayce",
  meaning: "Healer",
  letter: "J"
}, {
  name: "Jayden",
  meaning: "God has heard",
  letter: "J"
}, {
  name: "Jaylen",
  meaning: "Calm",
  letter: "J"
}, {
  name: "Jaymes",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jayon",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jayon",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jed",
  meaning: "Beloved of the Lord",
  letter: "J"
}, {
  name: "Jedidiah",
  meaning: "Beloved of the Lord",
  letter: "J"
}, {
  name: "Jeff",
  meaning: "Peace of God",
  letter: "J"
}, {
  name: "Jefferson",
  meaning: "Son of Jeffrey",
  letter: "J"
}, {
  name: "Jeffrey",
  meaning: "Peace of God",
  letter: "J"
}, {
  name: "Jensen",
  meaning: "Son of Jens",
  letter: "J"
}, {
  name: "Jeremiah",
  meaning: "God will uplift",
  letter: "J"
}, {
  name: "Jeremy",
  meaning: "God will uplift",
  letter: "J"
}, {
  name: "Jericho",
  meaning: "City of the moon",
  letter: "J"
}, {
  name: "Jermaine",
  meaning: "Brother",
  letter: "J"
}, {
  name: "Jerome",
  meaning: "Sacred name",
  letter: "J"
}, {
  name: "Jerry",
  meaning: "Spear ruler",
  letter: "J"
}, {
  name: "Jesse",
  meaning: "Gift",
  letter: "J"
}, {
  name: "Jett",
  meaning: "Jet black",
  letter: "J"
}, {
  name: "Jim",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Jimmy",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Joe",
  meaning: "God will add",
  letter: "J"
}, {
  name: "Joel",
  meaning: "Yahweh is God",
  letter: "J"
}, {
  name: "Joey",
  meaning: "God will add",
  letter: "J"
}, {
  name: "John",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Johnny",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jon",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jonah",
  meaning: "Dove",
  letter: "J"
}, {
  name: "Jonas",
  meaning: "Dove",
  letter: "J"
}, {
  name: "Jonathan",
  meaning: "God has given",
  letter: "J"
}, {
  name: "Jordan",
  meaning: "To flow down",
  letter: "J"
}, {
  name: "Jorge",
  meaning: "Farmer",
  letter: "J"
}, {
  name: "Jose",
  meaning: "God will add",
  letter: "J"
}, {
  name: "Joseph",
  meaning: "God will add",
  letter: "J"
}, {
  name: "Josh",
  meaning: "God is salvation",
  letter: "J"
}, {
  name: "Joshua",
  meaning: "God is salvation",
  letter: "J"
}, {
  name: "Josiah",
  meaning: "God supports",
  letter: "J"
}, {
  name: "Josue",
  meaning: "God is salvation",
  letter: "J"
}, {
  name: "Jovan",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Juan",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Judah",
  meaning: "Praised",
  letter: "J"
}, {
  name: "Jude",
  meaning: "Praised",
  letter: "J"
}, {
  name: "Julian",
  meaning: "Youthful",
  letter: "J"
}, {
  name: "Julio",
  meaning: "Youthful",
  letter: "J"
}, {
  name: "Julius",
  meaning: "Youthful",
  letter: "J"
}, {
  name: "Junior",
  meaning: "Younger",
  letter: "J"
}, {
  name: "Justice",
  meaning: "Fairness",
  letter: "J"
}, {
  name: "Justin",
  meaning: "Just, fair",
  letter: "J"
}, {
  name: "Justus",
  meaning: "Just, fair",
  letter: "J"
}, {
  name: "Kace",
  meaning: "Watchful",
  letter: "K"
}, {
  name: "Kade",
  meaning: "Round",
  letter: "K"
}, {
  name: "Kaden",
  meaning: "Companion",
  letter: "K"
}, {
  name: "Kai",
  meaning: "Sea",
  letter: "K"
}, {
  name: "Kaiden",
  meaning: "Companion",
  letter: "K"
}, {
  name: "Kaleb",
  meaning: "Devotion to God",
  letter: "K"
}, {
  name: "Kalel",
  meaning: "Voice of God",
  letter: "K"
}, {
  name: "Kane",
  meaning: "Warrior",
  letter: "K"
}, {
  name: "Kannon",
  meaning: "Clergyman",
  letter: "K"
}, {
  name: "Kareem",
  meaning: "Generous",
  letter: "K"
}, {
  name: "Karl",
  meaning: "Free man",
  letter: "K"
}, {
  name: "Karson",
  meaning: "Son of Carr",
  letter: "K"
}, {
  name: "Karter",
  meaning: "Cart driver",
  letter: "K"
}, {
  name: "Kase",
  meaning: "Box",
  letter: "K"
}, {
  name: "Kasen",
  meaning: "Pure",
  letter: "K"
}, {
  name: "Kash",
  meaning: "Hollow",
  letter: "K"
}, {
  name: "Kasper",
  meaning: "Treasurer",
  letter: "K"
}, {
  name: "Kayson",
  meaning: "Son of Kay",
  letter: "K"
}, {
  name: "Keanu",
  meaning: "Cool breeze",
  letter: "K"
}, {
  name: "Keaton",
  meaning: "Place of hawks",
  letter: "K"
}, {
  name: "Keegan",
  meaning: "Small flame",
  letter: "K"
}, {
  name: "Keenan",
  meaning: "Ancient",
  letter: "K"
}, {
  name: "Keith",
  meaning: "Wood",
  letter: "K"
}, {
  name: "Kellan",
  meaning: "Slender",
  letter: "K"
}, {
  name: "Kellen",
  meaning: "Slender",
  letter: "K"
}, {
  name: "Kellerman",
  meaning: "Cellar man",
  letter: "K"
}, {
  name: "Kelvin",
  meaning: "River man",
  letter: "K"
}, {
  name: "Ken",
  meaning: "Born of fire",
  letter: "K"
}, {
  name: "Kendall",
  meaning: "Valley of the River Kent",
  letter: "K"
}, {
  name: "Kendrick",
  meaning: "Greatest champion",
  letter: "K"
}, {
  name: "Kenneth",
  meaning: "Handsome",
  letter: "K"
}, {
  name: "Kenny",
  meaning: "Handsome",
  letter: "K"
}, {
  name: "Kent",
  meaning: "Coastal land",
  letter: "K"
}, {
  name: "Kenton",
  meaning: "The king's town",
  letter: "K"
}, {
  name: "Kenzo",
  meaning: "Strong and healthy",
  letter: "K"
}, {
  name: "Kevin",
  meaning: "Handsome",
  letter: "K"
}, {
  name: "Khalid",
  meaning: "Eternal",
  letter: "K"
}, {
  name: "Khalil",
  meaning: "Friend",
  letter: "K"
}, {
  name: "Kian",
  meaning: "Ancient",
  letter: "K"
}, {
  name: "Kiefer",
  meaning: "Pine tree",
  letter: "K"
}, {
  name: "Kieran",
  meaning: "Little dark one",
  letter: "K"
}, {
  name: "Killian",
  meaning: "Church",
  letter: "K"
}, {
  name: "King",
  meaning: "Ruler",
  letter: "K"
}, {
  name: "Kingsley",
  meaning: "King's meadow",
  letter: "K"
}, {
  name: "Kingston",
  meaning: "King's town",
  letter: "K"
}, {
  name: "Kip",
  meaning: "Pointed hill",
  letter: "K"
}, {
  name: "Kirby",
  meaning: "Church settlement",
  letter: "K"
}, {
  name: "Kirk",
  meaning: "Church",
  letter: "K"
}, {
  name: "Kit",
  meaning: "Bearer of Christ",
  letter: "K"
}, {
  name: "Klaus",
  meaning: "Victory of the people",
  letter: "K"
}, {
  name: "Knox",
  meaning: "Round hill",
  letter: "K"
}, {
  name: "Koa",
  meaning: "Warrior",
  letter: "K"
}, {
  name: "Kobe",
  meaning: "Supplanter",
  letter: "K"
}, {
  name: "Koby",
  meaning: "Supplanter",
  letter: "K"
}, {
  name: "Koda",
  meaning: "Friend",
  letter: "K"
}, {
  name: "Kody",
  meaning: "Helpful",
  letter: "K"
}, {
  name: "Kole",
  meaning: "Victory of the people",
  letter: "K"
}, {
  name: "Konnor",
  meaning: "Lover of hounds",
  letter: "K"
}, {
  name: "Korbin",
  meaning: "Raven",
  letter: "K"
}, {
  name: "Kristian",
  meaning: "Follower of Christ",
  letter: "K"
}, {
  name: "Kristopher",
  meaning: "Bearer of Christ",
  letter: "K"
}, {
  name: "Kurt",
  meaning: "Counselor",
  letter: "K"
}, {
  name: "Kyle",
  meaning: "Narrow strait",
  letter: "K"
}, {
  name: "Kyler",
  meaning: "Archer",
  letter: "K"
}, {
  name: "Kylo",
  meaning: "Sky",
  letter: "K"
}, {
  name: "Kyrie",
  meaning: "Lord",
  letter: "K"
}, {
  name: "Lachlan",
  meaning: "From the fjord-land",
  letter: "L"
}, {
  name: "Lamar",
  meaning: "Of the sea",
  letter: "L"
}, {
  name: "Lambert",
  meaning: "Bright land",
  letter: "L"
}, {
  name: "Lance",
  meaning: "Land",
  letter: "L"
}, {
  name: "Landon",
  meaning: "Long hill",
  letter: "L"
}, {
  name: "Lane",
  meaning: "Path",
  letter: "L"
}, {
  name: "Langston",
  meaning: "Long stone",
  letter: "L"
}, {
  name: "Larry",
  meaning: "Laurel",
  letter: "L"
}, {
  name: "Lars",
  meaning: "Laurel",
  letter: "L"
}, {
  name: "Laurence",
  meaning: "Laurel",
  letter: "L"
}, {
  name: "Lawrence",
  meaning: "Laurel",
  letter: "L"
}, {
  name: "Lawson",
  meaning: "Son of Lawrence",
  letter: "L"
}, {
  name: "Layne",
  meaning: "Path",
  letter: "L"
}, {
  name: "Layton",
  meaning: "Settlement with a leek garden",
  letter: "L"
}, {
  name: "Lazarus",
  meaning: "God has helped",
  letter: "L"
}, {
  name: "Leander",
  meaning: "Lion man",
  letter: "L"
}, {
  name: "Lee",
  meaning: "Meadow",
  letter: "L"
}, {
  name: "Leif",
  meaning: "Descendant",
  letter: "L"
}, {
  name: "Leighton",
  meaning: "Meadow town",
  letter: "L"
}, {
  name: "Leland",
  meaning: "Fallow land",
  letter: "L"
}, {
  name: "Lemuel",
  meaning: "Devoted to God",
  letter: "L"
}, {
  name: "Lenny",
  meaning: "Brave lion",
  letter: "L"
}, {
  name: "Lennon",
  meaning: "Lover",
  letter: "L"
}, {
  name: "Lennox",
  meaning: "Elm grove",
  letter: "L"
}, {
  name: "Leo",
  meaning: "Lion",
  letter: "L"
}, {
  name: "Leon",
  meaning: "Lion",
  letter: "L"
}, {
  name: "Leonard",
  meaning: "Brave lion",
  letter: "L"
}, {
  name: "Leonardo",
  meaning: "Brave lion",
  letter: "L"
}, {
  name: "Leonel",
  meaning: "Little lion",
  letter: "L"
}, {
  name: "Leopold",
  meaning: "Brave people",
  letter: "L"
}, {
  name: "Leroy",
  meaning: "The king",
  letter: "L"
}, {
  name: "Les",
  meaning: "Holly garden",
  letter: "L"
}, {
  name: "Leslie",
  meaning: "Holly garden",
  letter: "L"
}, {
  name: "Lester",
  meaning: "Fortress",
  letter: "L"
}, {
  name: "Levi",
  meaning: "Joined, attached",
  letter: "L"
}, {
  name: "Lewis",
  meaning: "Renowned warrior",
  letter: "L"
}, {
  name: "Liam",
  meaning: "Strong-willed warrior",
  letter: "L"
}, {
  name: "Lincoln",
  meaning: "Town by the pool",
  letter: "L"
}, {
  name: "Linus",
  meaning: "Flax",
  letter: "L"
}, {
  name: "Lionel",
  meaning: "Little lion",
  letter: "L"
}, {
  name: "Lloyd",
  meaning: "Gray",
  letter: "L"
}, {
  name: "Lochlan",
  meaning: "Land of the lakes",
  letter: "L"
}, {
  name: "Logan",
  meaning: "Little hollow",
  letter: "L"
}, {
  name: "Loki",
  meaning: "Trickster god",
  letter: "L"
}, {
  name: "Lorenzo",
  meaning: "Laurel",
  letter: "L"
}, {
  name: "Louie",
  meaning: "Renowned warrior",
  letter: "L"
}, {
  name: "Louis",
  meaning: "Renowned warrior",
  letter: "L"
}, {
  name: "Luc",
  meaning: "Light",
  letter: "L"
}, {
  name: "Luca",
  meaning: "Light",
  letter: "L"
}, {
  name: "Lucas",
  meaning: "Bringer of light",
  letter: "L"
}, {
  name: "Lucian",
  meaning: "Light",
  letter: "L"
}, {
  name: "Luciano",
  meaning: "Light",
  letter: "L"
}, {
  name: "Lucius",
  meaning: "Light",
  letter: "L"
}, {
  name: "Lucky",
  meaning: "Fortunate",
  letter: "L"
}, {
  name: "Ludwig",
  meaning: "Famous warrior",
  letter: "L"
}, {
  name: "Luis",
  meaning: "Renowned warrior",
  letter: "L"
}, {
  name: "Luka",
  meaning: "Light",
  letter: "L"
}, {
  name: "Lukas",
  meaning: "Light",
  letter: "L"
}, {
  name: "Luke",
  meaning: "Light",
  letter: "L"
}, {
  name: "Luther",
  meaning: "Army of the people",
  letter: "L"
}, {
  name: "Lyle",
  meaning: "Island",
  letter: "L"
}, {
  name: "Lyndon",
  meaning: "Linden tree hill",
  letter: "L"
}, {
  name: "Mac",
  meaning: "Son of",
  letter: "M"
}, {
  name: "Mack",
  meaning: "Son of",
  letter: "M"
}, {
  name: "Madden",
  meaning: "Little dog",
  letter: "M"
}, {
  name: "Maddox",
  meaning: "Son of Madoc",
  letter: "M"
}, {
  name: "Magnus",
  meaning: "Great",
  letter: "M"
}, {
  name: "Major",
  meaning: "Greater",
  letter: "M"
}, {
  name: "Malachi",
  meaning: "My messenger",
  letter: "M"
}, {
  name: "Malcolm",
  meaning: "Disciple of Saint Columba",
  letter: "M"
}, {
  name: "Malik",
  meaning: "King",
  letter: "M"
}, {
  name: "Manuel",
  meaning: "God is with us",
  letter: "M"
}, {
  name: "Marc",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Marcel",
  meaning: "Little warrior",
  letter: "M"
}, {
  name: "Marco",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Marcos",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Marcus",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Mario",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Mark",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Marlon",
  meaning: "Little hawk",
  letter: "M"
}, {
  name: "Marshall",
  meaning: "Horse servant",
  letter: "M"
}, {
  name: "Martin",
  meaning: "Warlike",
  letter: "M"
}, {
  name: "Marvin",
  meaning: "Sea friend",
  letter: "M"
}, {
  name: "Mason",
  meaning: "Worker in stone",
  letter: "M"
}, {
  name: "Mateo",
  meaning: "Gift of God",
  letter: "M"
}, {
  name: "Mathew",
  meaning: "Gift of God",
  letter: "M"
}, {
  name: "Mathias",
  meaning: "Gift of God",
  letter: "M"
}, {
  name: "Matteo",
  meaning: "Gift of God",
  letter: "M"
}, {
  name: "Matthew",
  meaning: "Gift of God",
  letter: "M"
}, {
  name: "Matthias",
  meaning: "Gift of God",
  letter: "M"
}, {
  name: "Maurice",
  meaning: "Dark-skinned",
  letter: "M"
}, {
  name: "Maverick",
  meaning: "Independent",
  letter: "M"
}, {
  name: "Max",
  meaning: "Greatest",
  letter: "M"
}, {
  name: "Maximilian",
  meaning: "Greatest",
  letter: "M"
}, {
  name: "Maximus",
  meaning: "Greatest",
  letter: "M"
}, {
  name: "Maxwell",
  meaning: "Great stream",
  letter: "M"
}, {
  name: "Mayson",
  meaning: "Stone worker",
  letter: "M"
}, {
  name: "Melvin",
  meaning: "Gentle friend",
  letter: "M"
}, {
  name: "Memphis",
  meaning: "Enduring and beautiful",
  letter: "M"
}, {
  name: "Micah",
  meaning: "Who is like God?",
  letter: "M"
}, {
  name: "Michael",
  meaning: "Who is like God?",
  letter: "M"
}, {
  name: "Miguel",
  meaning: "Who is like God?",
  letter: "M"
}, {
  name: "Mike",
  meaning: "Who is like God?",
  letter: "M"
}, {
  name: "Miles",
  meaning: "Soldier or merciful",
  letter: "M"
}, {
  name: "Miller",
  meaning: "Grinder of grain",
  letter: "M"
}, {
  name: "Milo",
  meaning: "Soldier or merciful",
  letter: "M"
}, {
  name: "Milton",
  meaning: "Mill town",
  letter: "M"
}, {
  name: "Mitchell",
  meaning: "Who is like God?",
  letter: "M"
}, {
  name: "Mohamed",
  meaning: "Praiseworthy",
  letter: "M"
}, {
  name: "Mohammad",
  meaning: "Praiseworthy",
  letter: "M"
}, {
  name: "Mohammed",
  meaning: "Praiseworthy",
  letter: "M"
}, {
  name: "Moises",
  meaning: "Drawn out of the water",
  letter: "M"
}, {
  name: "Morgan",
  meaning: "Sea-born",
  letter: "M"
}, {
  name: "Morris",
  meaning: "Dark-skinned",
  letter: "M"
}, {
  name: "Moses",
  meaning: "Drawn out of the water",
  letter: "M"
}, {
  name: "Murphy",
  meaning: "Sea warrior",
  letter: "M"
}, {
  name: "Murray",
  meaning: "Sea settlement",
  letter: "M"
}, {
  name: "Myles",
  meaning: "Soldier",
  letter: "M"
}, {
  name: "Myron",
  meaning: "Fragrant oil",
  letter: "M"
}, {
  name: "Nadir",
  meaning: "Rare",
  letter: "N"
}, {
  name: "Nash",
  meaning: "By the ash tree",
  letter: "N"
}, {
  name: "Nasir",
  meaning: "Helper",
  letter: "N"
}, {
  name: "Nate",
  meaning: "Gift of God",
  letter: "N"
}, {
  name: "Nathan",
  meaning: "Gift of God",
  letter: "N"
}, {
  name: "Nathaniel",
  meaning: "Gift of God",
  letter: "N"
}, {
  name: "Neal",
  meaning: "Cloud",
  letter: "N"
}, {
  name: "Nehemiah",
  meaning: "Comforted by God",
  letter: "N"
}, {
  name: "Neil",
  meaning: "Cloud",
  letter: "N"
}, {
  name: "Nelson",
  meaning: "Son of Neil",
  letter: "N"
}, {
  name: "Neo",
  meaning: "New",
  letter: "N"
}, {
  name: "Neville",
  meaning: "New town",
  letter: "N"
}, {
  name: "Niall",
  meaning: "Cloud",
  letter: "N"
}, {
  name: "Nicholas",
  meaning: "Victory of the people",
  letter: "N"
}, {
  name: "Nick",
  meaning: "Victory of the people",
  letter: "N"
}, {
  name: "Nico",
  meaning: "People of victory",
  letter: "N"
}, {
  name: "Nicolas",
  meaning: "Victory of the people",
  letter: "N"
}, {
  name: "Nigel",
  meaning: "Dark",
  letter: "N"
}, {
  name: "Nikhil",
  meaning: "Whole",
  letter: "N"
}, {
  name: "Nikos",
  meaning: "Victory of the people",
  letter: "N"
}, {
  name: "Nile",
  meaning: "From the Nile",
  letter: "N"
}, {
  name: "Nils",
  meaning: "Victory of the people",
  letter: "N"
}, {
  name: "Nixon",
  meaning: "Son of Nicholas",
  letter: "N"
}, {
  name: "Noah",
  meaning: "Rest, wandering",
  letter: "N"
}, {
  name: "Noam",
  meaning: "Pleasantness",
  letter: "N"
}, {
  name: "Noble",
  meaning: "Aristocratic",
  letter: "N"
}, {
  name: "Noel",
  meaning: "Christmas",
  letter: "N"
}, {
  name: "Nolan",
  meaning: "Champion",
  letter: "N"
}, {
  name: "Norman",
  meaning: "Northman",
  letter: "N"
}, {
  name: "Norris",
  meaning: "Northerner",
  letter: "N"
}, {
  name: "Norton",
  meaning: "North town",
  letter: "N"
}, {
  name: "Nova",
  meaning: "New",
  letter: "N"
}, {
  name: "Nyle",
  meaning: "Island",
  letter: "N"
}, {
  name: "Oakley",
  meaning: "Oak wood",
  letter: "O"
}, {
  name: "Obadiah",
  meaning: "Servant of God",
  letter: "O"
}, {
  name: "Ocean",
  meaning: "Sea",
  letter: "O"
}, {
  name: "Octavio",
  meaning: "Eighth",
  letter: "O"
}, {
  name: "Odin",
  meaning: "Inspiration",
  letter: "O"
}, {
  name: "Olaf",
  meaning: "Ancestor's relic",
  letter: "O"
}, {
  name: "Oliver",
  meaning: "Olive tree",
  letter: "O"
}, {
  name: "Olivier",
  meaning: "Olive tree",
  letter: "O"
}, {
  name: "Ollie",
  meaning: "Olive tree",
  letter: "O"
}, {
  name: "Omar",
  meaning: "Flourishing",
  letter: "O"
}, {
  name: "Omari",
  meaning: "God the highest",
  letter: "O"
}, {
  name: "Orion",
  meaning: "Rising star",
  letter: "O"
}, {
  name: "Orlando",
  meaning: "Famous land",
  letter: "O"
}, {
  name: "Orson",
  meaning: "Bear cub",
  letter: "O"
}, {
  name: "Oscar",
  meaning: "God spear",
  letter: "O"
}, {
  name: "Osiris",
  meaning: "Powerful",
  letter: "O"
}, {
  name: "Osman",
  meaning: "God's protection",
  letter: "O"
}, {
  name: "Oswald",
  meaning: "Divine power",
  letter: "O"
}, {
  name: "Otis",
  meaning: "Wealthy",
  letter: "O"
}, {
  name: "Otto",
  meaning: "Wealth",
  letter: "O"
}, {
  name: "Owen",
  meaning: "Young warrior",
  letter: "O"
}, {
  name: "Ozzie",
  meaning: "Divine power",
  letter: "O"
}, {
  name: "Ozzy",
  meaning: "Divine power",
  letter: "O"
}, {
  name: "Pablo",
  meaning: "Small",
  letter: "P"
}, {
  name: "Pace",
  meaning: "Peace",
  letter: "P"
}, {
  name: "Palmer",
  meaning: "Palm bearer",
  letter: "P"
}, {
  name: "Parker",
  meaning: "Park keeper",
  letter: "P"
}, {
  name: "Pascal",
  meaning: "Easter",
  letter: "P"
}, {
  name: "Pat",
  meaning: "Noble",
  letter: "P"
}, {
  name: "Patrick",
  meaning: "Noble, patrician",
  letter: "P"
}, {
  name: "Paul",
  meaning: "Small",
  letter: "P"
}, {
  name: "Pax",
  meaning: "Peace",
  letter: "P"
}, {
  name: "Paxton",
  meaning: "Peace town",
  letter: "P"
}, {
  name: "Payton",
  meaning: "Fighting man's estate",
  letter: "P"
}, {
  name: "Pedro",
  meaning: "Rock",
  letter: "P"
}, {
  name: "Percy",
  meaning: "Pierce valley",
  letter: "P"
}, {
  name: "Peregrine",
  meaning: "Traveler",
  letter: "P"
}, {
  name: "Perry",
  meaning: "Pear tree",
  letter: "P"
}, {
  name: "Peter",
  meaning: "Rock",
  letter: "P"
}, {
  name: "Peyton",
  meaning: "Fighting man's estate",
  letter: "P"
}, {
  name: "Phil",
  meaning: "Lover of horses",
  letter: "P"
}, {
  name: "Philip",
  meaning: "Lover of horses",
  letter: "P"
}, {
  name: "Phillip",
  meaning: "Lover of horses",
  letter: "P"
}, {
  name: "Phineas",
  meaning: "Oracle",
  letter: "P"
}, {
  name: "Phoenix",
  meaning: "Dark red",
  letter: "P"
}, {
  name: "Pierce",
  meaning: "Rock",
  letter: "P"
}, {
  name: "Pierre",
  meaning: "Rock",
  letter: "P"
}, {
  name: "Piers",
  meaning: "Rock",
  letter: "P"
}, {
  name: "Porter",
  meaning: "Gatekeeper",
  letter: "P"
}, {
  name: "Preston",
  meaning: "Priest's estate",
  letter: "P"
}, {
  name: "Prince",
  meaning: "Royal son",
  letter: "P"
}, {
  name: "Quade",
  meaning: "Fourth",
  letter: "Q"
}, {
  name: "Quartz",
  meaning: "Hard mineral",
  letter: "Q"
}, {
  name: "Quentin",
  meaning: "Fifth",
  letter: "Q"
}, {
  name: "Quill",
  meaning: "Feather",
  letter: "Q"
}, {
  name: "Quillan",
  meaning: "Cub",
  letter: "Q"
}, {
  name: "Quincy",
  meaning: "Estate of the fifth son",
  letter: "Q"
}, {
  name: "Quinn",
  meaning: "Descendant of Conn",
  letter: "Q"
}, {
  name: "Quinnlan",
  meaning: "Strong",
  letter: "Q"
}, {
  name: "Quinton",
  meaning: "Queen's settlement",
  letter: "Q"
}, {
  name: "Rafael",
  meaning: "God has healed",
  letter: "R"
}, {
  name: "Raiden",
  meaning: "Thunder and lightning",
  letter: "R"
}, {
  name: "Ralph",
  meaning: "Wolf counsel",
  letter: "R"
}, {
  name: "Ramiro",
  meaning: "Famous counselor",
  letter: "R"
}, {
  name: "Ramon",
  meaning: "Wise protector",
  letter: "R"
}, {
  name: "Randall",
  meaning: "Shield wolf",
  letter: "R"
}, {
  name: "Randy",
  meaning: "Shield wolf",
  letter: "R"
}, {
  name: "Raphael",
  meaning: "God has healed",
  letter: "R"
}, {
  name: "Rashad",
  meaning: "Good guidance",
  letter: "R"
}, {
  name: "Raul",
  meaning: "Wolf counsel",
  letter: "R"
}, {
  name: "Ray",
  meaning: "Wise protector",
  letter: "R"
}, {
  name: "Raymond",
  meaning: "Wise protector",
  letter: "R"
}, {
  name: "Reece",
  meaning: "Enthusiasm",
  letter: "R"
}, {
  name: "Reed",
  meaning: "Red-haired",
  letter: "R"
}, {
  name: "Reese",
  meaning: "Enthusiasm",
  letter: "R"
}, {
  name: "Reggie",
  meaning: "Counsel power",
  letter: "R"
}, {
  name: "Reginald",
  meaning: "Counsel power",
  letter: "R"
}, {
  name: "Reid",
  meaning: "Red-haired",
  letter: "R"
}, {
  name: "Remington",
  meaning: "Raven's town",
  letter: "R"
}, {
  name: "Remy",
  meaning: "Oarsman",
  letter: "R"
}, {
  name: "Rene",
  meaning: "Reborn",
  letter: "R"
}, {
  name: "Reuben",
  meaning: "Behold, a son",
  letter: "R"
}, {
  name: "Rex",
  meaning: "King",
  letter: "R"
}, {
  name: "Rhett",
  meaning: "Advice",
  letter: "R"
}, {
  name: "Rhys",
  meaning: "Enthusiasm",
  letter: "R"
}, {
  name: "Ricardo",
  meaning: "Brave ruler",
  letter: "R"
}, {
  name: "Richard",
  meaning: "Brave ruler",
  letter: "R"
}, {
  name: "Richie",
  meaning: "Brave ruler",
  letter: "R"
}, {
  name: "Rick",
  meaning: "Brave ruler",
  letter: "R"
}, {
  name: "Ricky",
  meaning: "Brave ruler",
  letter: "R"
}, {
  name: "Ridge",
  meaning: "Mountain crest",
  letter: "R"
}, {
  name: "Riley",
  meaning: "Courageous",
  letter: "R"
}, {
  name: "River",
  meaning: "Flowing water",
  letter: "R"
}, {
  name: "Robert",
  meaning: "Bright fame",
  letter: "R"
}, {
  name: "Roberto",
  meaning: "Bright fame",
  letter: "R"
}, {
  name: "Robin",
  meaning: "Bright fame",
  letter: "R"
}, {
  name: "Rocco",
  meaning: "Rest",
  letter: "R"
}, {
  name: "Rocky",
  meaning: "Rest",
  letter: "R"
}, {
  name: "Rodney",
  meaning: "Hroda's island",
  letter: "R"
}, {
  name: "Rodrigo",
  meaning: "Famous ruler",
  letter: "R"
}, {
  name: "Roger",
  meaning: "Famous spear",
  letter: "R"
}, {
  name: "Roland",
  meaning: "Famous land",
  letter: "R"
}, {
  name: "Roman",
  meaning: "Citizen of Rome",
  letter: "R"
}, {
  name: "Romeo",
  meaning: "Pilgrim to Rome",
  letter: "R"
}, {
  name: "Ron",
  meaning: "Counsel power",
  letter: "R"
}, {
  name: "Ronald",
  meaning: "Counsel power",
  letter: "R"
}, {
  name: "Ronan",
  meaning: "Little seal",
  letter: "R"
}, {
  name: "Ronnie",
  meaning: "Counsel power",
  letter: "R"
}, {
  name: "Rory",
  meaning: "Red king",
  letter: "R"
}, {
  name: "Roscoe",
  meaning: "Deer forest",
  letter: "R"
}, {
  name: "Ross",
  meaning: "Promontory",
  letter: "R"
}, {
  name: "Rowan",
  meaning: "Little redhead",
  letter: "R"
}, {
  name: "Roy",
  meaning: "King",
  letter: "R"
}, {
  name: "Royce",
  meaning: "Son of the king",
  letter: "R"
}, {
  name: "Ruben",
  meaning: "Behold, a son",
  letter: "R"
}, {
  name: "Rudy",
  meaning: "Famous wolf",
  letter: "R"
}, {
  name: "Rufus",
  meaning: "Red-haired",
  letter: "R"
}, {
  name: "Russell",
  meaning: "Red-haired",
  letter: "R"
}, {
  name: "Ryan",
  meaning: "Little king",
  letter: "R"
}, {
  name: "Ryder",
  meaning: "Cavalryman",
  letter: "R"
}, {
  name: "Ryker",
  meaning: "Rich",
  letter: "R"
}, {
  name: "Rylan",
  meaning: "Island meadow",
  letter: "R"
}, {
  name: "Ryland",
  meaning: "Island meadow",
  letter: "R"
}, {
  name: "Sam",
  meaning: "Told by God",
  letter: "S"
}, {
  name: "Samson",
  meaning: "Sun",
  letter: "S"
}, {
  name: "Samuel",
  meaning: "Told by God",
  letter: "S"
}, {
  name: "Santiago",
  meaning: "Saint James",
  letter: "S"
}, {
  name: "Santino",
  meaning: "Little saint",
  letter: "S"
}, {
  name: "Saul",
  meaning: "Asked for",
  letter: "S"
}, {
  name: "Sawyer",
  meaning: "Woodcutter",
  letter: "S"
}, {
  name: "Scott",
  meaning: "From Scotland",
  letter: "S"
}, {
  name: "Seamus",
  meaning: "Supplanter",
  letter: "S"
}, {
  name: "Sean",
  meaning: "God is gracious",
  letter: "S"
}, {
  name: "Sebastian",
  meaning: "Venerable",
  letter: "S"
}, {
  name: "Seth",
  meaning: "Appointed",
  letter: "S"
}, {
  name: "Shane",
  meaning: "God is gracious",
  letter: "S"
}, {
  name: "Shaun",
  meaning: "God is gracious",
  letter: "S"
}, {
  name: "Shawn",
  meaning: "God is gracious",
  letter: "S"
}, {
  name: "Shepherd",
  meaning: "Sheep herder",
  letter: "S"
}, {
  name: "Sherman",
  meaning: "Shearman",
  letter: "S"
}, {
  name: "Sidney",
  meaning: "Wide island",
  letter: "S"
}, {
  name: "Silas",
  meaning: "Wood, forest",
  letter: "S"
}, {
  name: "Simeon",
  meaning: "God has heard",
  letter: "S"
}, {
  name: "Simon",
  meaning: "God has heard",
  letter: "S"
}, {
  name: "Sincere",
  meaning: "Honest",
  letter: "S"
}, {
  name: "Skylar",
  meaning: "Scholar",
  letter: "S"
}, {
  name: "Solomon",
  meaning: "Peace",
  letter: "S"
}, {
  name: "Soren",
  meaning: "Stern",
  letter: "S"
}, {
  name: "Spencer",
  meaning: "Steward",
  letter: "S"
}, {
  name: "Stanley",
  meaning: "Stone meadow",
  letter: "S"
}, {
  name: "Stefan",
  meaning: "Crown",
  letter: "S"
}, {
  name: "Stephen",
  meaning: "Crown",
  letter: "S"
}, {
  name: "Sterling",
  meaning: "Little star",
  letter: "S"
}, {
  name: "Steven",
  meaning: "Crown",
  letter: "S"
}, {
  name: "Stellan",
  meaning: "Calm",
  letter: "S"
}, {
  name: "Stewart",
  meaning: "Steward",
  letter: "S"
}, {
  name: "Sullivan",
  meaning: "Dark-eyed",
  letter: "S"
}, {
  name: "Sutton",
  meaning: "Southern town",
  letter: "S"
}, {
  name: "Sylvester",
  meaning: "Wooded",
  letter: "S"
}, {
  name: "Tanner",
  meaning: "Leather maker",
  letter: "T"
}, {
  name: "Tate",
  meaning: "Cheerful",
  letter: "T"
}, {
  name: "Tatum",
  meaning: "Tate's homestead",
  letter: "T"
}, {
  name: "Taylor",
  meaning: "Tailor",
  letter: "T"
}, {
  name: "Teagan",
  meaning: "Little poet",
  letter: "T"
}, {
  name: "Ted",
  meaning: "Wealthy guardian",
  letter: "T"
}, {
  name: "Teddy",
  meaning: "Wealthy guardian",
  letter: "T"
}, {
  name: "Terence",
  meaning: "Smooth",
  letter: "T"
}, {
  name: "Terrance",
  meaning: "Smooth",
  letter: "T"
}, {
  name: "Terrell",
  meaning: "Stubborn",
  letter: "T"
}, {
  name: "Terrence",
  meaning: "Smooth",
  letter: "T"
}, {
  name: "Terry",
  meaning: "Smooth",
  letter: "T"
}, {
  name: "Thaddeus",
  meaning: "Heart",
  letter: "T"
}, {
  name: "Thatcher",
  meaning: "Roof fixer",
  letter: "T"
}, {
  name: "Theo",
  meaning: "Divine gift",
  letter: "T"
}, {
  name: "Theodore",
  meaning: "Gift of God",
  letter: "T"
}, {
  name: "Thomas",
  meaning: "Twin",
  letter: "T"
}, {
  name: "Timothy",
  meaning: "Honoring God",
  letter: "T"
}, {
  name: "Titus",
  meaning: "Title of honor",
  letter: "T"
}, {
  name: "Tobias",
  meaning: "God is good",
  letter: "T"
}, {
  name: "Tobin",
  meaning: "God is good",
  letter: "T"
}, {
  name: "Toby",
  meaning: "God is good",
  letter: "T"
}, {
  name: "Todd",
  meaning: "Fox",
  letter: "T"
}, {
  name: "Tom",
  meaning: "Twin",
  letter: "T"
}, {
  name: "Tomas",
  meaning: "Twin",
  letter: "T"
}, {
  name: "Tommy",
  meaning: "Twin",
  letter: "T"
}, {
  name: "Tony",
  meaning: "Priceless one",
  letter: "T"
}, {
  name: "Trace",
  meaning: "Path",
  letter: "T"
}, {
  name: "Travis",
  meaning: "To cross",
  letter: "T"
}, {
  name: "Trent",
  meaning: "Gushing water",
  letter: "T"
}, {
  name: "Trenton",
  meaning: "Trent's town",
  letter: "T"
}, {
  name: "Trevor",
  meaning: "Large settlement",
  letter: "T"
}, {
  name: "Trey",
  meaning: "Three",
  letter: "T"
}, {
  name: "Tristan",
  meaning: "Sorrowful",
  letter: "T"
}, {
  name: "Troy",
  meaning: "Foot soldier",
  letter: "T"
}, {
  name: "Truett",
  meaning: "River bend",
  letter: "T"
}, {
  name: "Truman",
  meaning: "Loyal man",
  letter: "T"
}, {
  name: "Tucker",
  meaning: "Fabric pleater",
  letter: "T"
}, {
  name: "Turner",
  meaning: "Lathe worker",
  letter: "T"
}, {
  name: "Ty",
  meaning: "House",
  letter: "T"
}, {
  name: "Tyler",
  meaning: "Tile maker",
  letter: "T"
}, {
  name: "Tyson",
  meaning: "Firebrand",
  letter: "T"
}, {
  name: "Ulysses",
  meaning: "Wrathful",
  letter: "U"
}, {
  name: "Umar",
  meaning: "Flourishing",
  letter: "U"
}, {
  name: "Upton",
  meaning: "Upper town",
  letter: "U"
}, {
  name: "Urban",
  meaning: "From the city",
  letter: "U"
}, {
  name: "Uriah",
  meaning: "God is my light",
  letter: "U"
}, {
  name: "Uriel",
  meaning: "God is my light",
  letter: "U"
}, {
  name: "Usher",
  meaning: "Doorkeeper",
  letter: "U"
}, {
  name: "Val",
  meaning: "Strong",
  letter: "V"
}, {
  name: "Valentino",
  meaning: "Strength, health",
  letter: "V"
}, {
  name: "Van",
  meaning: "Of",
  letter: "V"
}, {
  name: "Vance",
  meaning: "Marshland",
  letter: "V"
}, {
  name: "Vaughn",
  meaning: "Small",
  letter: "V"
}, {
  name: "Vic",
  meaning: "Conqueror",
  letter: "V"
}, {
  name: "Victor",
  meaning: "Conqueror",
  letter: "V"
}, {
  name: "Viggo",
  meaning: "War",
  letter: "V"
}, {
  name: "Vincent",
  meaning: "Conquering",
  letter: "V"
}, {
  name: "Vincenzo",
  meaning: "Conquering",
  letter: "V"
}, {
  name: "Vito",
  meaning: "Life",
  letter: "V"
}, {
  name: "Vladimir",
  meaning: "Famous ruler",
  letter: "V"
}, {
  name: "Wade",
  meaning: "To ford",
  letter: "W"
}, {
  name: "Walker",
  meaning: "Cloth walker",
  letter: "W"
}, {
  name: "Wallace",
  meaning: "Foreigner",
  letter: "W"
}, {
  name: "Walter",
  meaning: "Army ruler",
  letter: "W"
}, {
  name: "Warren",
  meaning: "Park keeper",
  letter: "W"
}, {
  name: "Watson",
  meaning: "Son of Walter",
  letter: "W"
}, {
  name: "Waylon",
  meaning: "Land by the road",
  letter: "W"
}, {
  name: "Wayne",
  meaning: "Wagon maker",
  letter: "W"
}, {
  name: "Wells",
  meaning: "Spring",
  letter: "W"
}, {
  name: "Wesley",
  meaning: "Western meadow",
  letter: "W"
}, {
  name: "Weston",
  meaning: "From the western town",
  letter: "W"
}, {
  name: "Wilder",
  meaning: "Untamed",
  letter: "W"
}, {
  name: "Will",
  meaning: "Resolute protector",
  letter: "W"
}, {
  name: "William",
  meaning: "Resolute protector",
  letter: "W"
}, {
  name: "Wilson",
  meaning: "Son of Will",
  letter: "W"
}, {
  name: "Winston",
  meaning: "Joy stone",
  letter: "W"
}, {
  name: "Wolf",
  meaning: "Traveling wolf",
  letter: "W"
}, {
  name: "Wyatt",
  meaning: "Brave in war",
  letter: "W"
}, {
  name: "Xander",
  meaning: "Defender of the people",
  letter: "X"
}, {
  name: "Xanthus",
  meaning: "Golden-haired",
  letter: "X"
}, {
  name: "Xavi",
  meaning: "New house",
  letter: "X"
}, {
  name: "Xavier",
  meaning: "New house",
  letter: "X"
}, {
  name: "Xenon",
  meaning: "Stranger",
  letter: "X"
}, {
  name: "Xerxes",
  meaning: "Hero among rulers",
  letter: "X"
}, {
  name: "Xylon",
  meaning: "From the forest",
  letter: "X"
}, {
  name: "Yael",
  meaning: "Mountain goat",
  letter: "Y"
}, {
  name: "Yahir",
  meaning: "He enlightens",
  letter: "Y"
}, {
  name: "Yanis",
  meaning: "Gift of God",
  letter: "Y"
}, {
  name: "Yardley",
  meaning: "Wood clearing",
  letter: "Y"
}, {
  name: "Yasin",
  meaning: "Rich",
  letter: "Y"
}, {
  name: "Yosef",
  meaning: "God will add",
  letter: "Y"
}, {
  name: "Yuri",
  meaning: "Farmer",
  letter: "Y"
}, {
  name: "Yusuf",
  meaning: "God increases",
  letter: "Y"
}, {
  name: "Zachary",
  meaning: "The Lord has remembered",
  letter: "Z"
}, {
  name: "Zander",
  meaning: "Defender of men",
  letter: "Z"
}, {
  name: "Zane",
  meaning: "God is gracious",
  letter: "Z"
}, {
  name: "Zayd",
  meaning: "Abundance",
  letter: "Z"
}, {
  name: "Zeke",
  meaning: "God strengthens",
  letter: "Z"
}, {
  name: "Zephyr",
  meaning: "West wind",
  letter: "Z"
}, {
  name: "Zev",
  meaning: "Wolf",
  letter: "Z"
}, {
  name: "Zion",
  meaning: "Highest point",
  letter: "Z"
}, {
  name: "Zyaire",
  meaning: "River",
  letter: "Z"
}];
const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
export default function BoyNameDirectory() {
  return <section id="boy-name-directory" className="bg-background py-16 px-4 md:px-8 font-sans min-h-screen">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-12">
        
        <div className="lg:col-span-3">
          <div className="mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-[var(--chart-1)] mb-6 tracking-tight">
              Boy Name Directory
            </h1>
            <p className="text-lg text-foreground max-w-2xl leading-relaxed">
              An intensive alphabetical directory of popular and classic names for boys. 
              Browse through our curated collection and hover over any name to discover its beautiful meaning and origin.
            </p>
          </div>

          <div className="space-y-24">
            {alphabet.map((letter, letterIndex) => {
            const namesForLetter = namesData.filter(n => n.letter === letter);
            if (namesForLetter.length === 0) return null;
            return <div key={letter} data-index={letterIndex} id={`letter-${letter}`} className="scroll-mt-32">
                  <h2 className="text-7xl md:text-9xl font-bold text-[var(--chart-1)] mb-10 border-b-2 border-border/40 pb-4 tracking-tighter opacity-90">
                    {letter}
                  </h2>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4">
                    {namesForLetter.map((name, nameIndex) => <div key={`${name.name}-${nameIndex}`} data-index={nameIndex}>
                        <TooltipProvider delayDuration={200}>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              {name.url ? <Link to={name.url} newTab target="_blank" rel="noopener noreferrer" className="block px-4 py-3 text-lg text-foreground hover:bg-accent hover:text-foreground transition-all duration-300 rounded-sm border border-transparent hover:border-accent-foreground/10 hover:shadow-sm">
                                  {name.name}
                                </Link> : <div className="px-4 py-3 text-lg text-foreground hover:bg-accent hover:text-foreground transition-all duration-300 cursor-default rounded-sm border border-transparent hover:border-accent-foreground/10 hover:shadow-sm">
                                  {name.name}
                                </div>}
                            </TooltipTrigger>
                            <TooltipContent side="top" className="bg-[var(--chart-1)] text-primary-foreground border-none shadow-md px-4 py-2">
                              <p className="font-medium text-sm tracking-wide">{name.meaning}</p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </div>)}
                  </div>
                </div>;
          })}
          </div>
        </div>

        <div className="hidden lg:block lg:col-span-1">
          <div className="sticky top-32 bg-card p-8 shadow-sm border border-border/30 rounded-sm">
            <h3 className="text-lg font-bold text-[var(--chart-1)] mb-6 uppercase tracking-widest border-b border-border/40 pb-3">
              Quick Jump
            </h3>
            <div className="grid grid-cols-4 gap-3">
              {alphabet.map((letter, index) => <div key={letter} data-index={index}>
                  <Link to={`#letter-${letter}`} className="flex items-center justify-center w-full aspect-square bg-background text-foreground hover:bg-accent hover:text-foreground transition-colors duration-200 text-base font-semibold shadow-xs border border-border/20 rounded-sm" aria-label={`Jump to letter ${letter}`}>
                    {letter}
                  </Link>
                </div>)}
            </div>
          </div>
        </div>

      </div>
    </section>;
}